var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"header-burger",class:{ 'is-open': _vm.state, 'is-closed': _vm.isClosed }},[_c('span',{staticClass:"header-burger__wrap"},_vm._l((3),function(index){return _c('span',{key:index,staticClass:"header-burger__line"})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }